import { identity } from 'lodash';
import simpleSoilAttribute from './simpleSoilAttribute';

export const REPRESENTATIVE_SLOPE = simpleSoilAttribute({
  key: 'Representative Slope',
  ratingCol: {
    displayString: 'Slope gradient',
    accessor: 'mapUnitRatingString',
    format: (percent: Nullable<string>) =>
      percent == null ? 'N/A' : `${percent}%`,
    csvFormat: identity,
  },
  ruleId: '96',
  units: '% slope gradient',
});
